import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import "./assets/css/tailwind.css";
import "@db-ui/core/dist/css/db-ui-core.vars.css";
import "./assets/scss/_main.scss";
import { i18n } from "@/i18n/i18n";

const app = createApp(App);
app.use(i18n);
app.use(store);
app.use(router);
app.mount("#app");
